import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, matchPath } from 'react-router-dom';
import Breadcrumbs from '../Helpers/Breadcrumbs';
import Shortcuts from '../UI/Shortcut';
import { ROUTES } from '../../routes';

class PageTitle extends Component {
  findTitle() {
    const route = ROUTES.find(r => matchPath(this.props.location.pathname, r));

    return route ? route.title : null;
  }

  render() {
    return (
      <div className="page-title">
        <Breadcrumbs />

        <h1>{this.findTitle()}</h1>

        <Shortcuts />
      </div>
    );
  }
}

PageTitle.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(PageTitle);



// WEBPACK FOOTER //
// ./src/Shared/Helpers/PageTitle.js